// NT

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

// NT - Cart
if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();


      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({
          note: event.target.value
        });
        fetch(`${routes.cart_update_url}`, {
          ...fetchConfig(),
          ...{
            body
          }
        });
      }, 300))
    }
  });
};

if (!customElements.get('gift-toggle')) {
  customElements.define('gift-toggle', class GiftToggle extends HTMLElement {
    constructor() {
      super();


      this.addEventListener('change', debounce((event) => {
        let input = this.querySelector('input');
        const body = JSON.stringify({
          attributes: {
            'This is a gift': input.checked ? 'Yes' : 'No'
          }
        });
        fetch(`${routes.cart_update_url}`, {
          ...fetchConfig(),
          ...{
            body
          }
        });
      }, 300))
    }
  });
};

// Consultation Form
function consultationToggle() {
  document.querySelector('.consultation-form').classList.toggle('active');
}

var consulationToggles = document.querySelectorAll('.consultation-toggle');

if (consulationToggles) {
  consulationToggles.forEach((targetDetail) => {
    targetDetail.addEventListener('click', (event) => {
      event.preventDefault();
      consultationToggle();
    })
  });

}

// Made-to-Measure Form
function mtmToggle() {
  document.querySelector('.mtm-form').classList.toggle('active');
}
if (document.querySelector('.mtm-toggle')) {
  document.querySelector('.mtm-toggle').addEventListener('click', (event) => {
    event.preventDefault();
    mtmToggle();
  })
}

function toggleAssociates(form, val) {
  var formContainer = document.querySelector(form);

  var formOptions = formContainer.querySelectorAll("option:not(.default)");

  for (i = 0; i < formOptions.length; i++) {
    if (formOptions[i].getAttribute("data-store") == val) {
      formOptions[i].style.display = "block";
      formOptions[i].setAttribute("data-active", true);
    } else {
      formOptions[i].style.display = "none";
      formOptions[i].removeAttribute("data-active");
    }
  }

  formContainer.value = formContainer.querySelector(".default").getAttribute("value");
}


// formspark made to measure
var mtmForm = document.querySelector('#mtmenquiry');
if (mtmForm != null) {
  const botpoison = new Botpoison({
    publicKey: "pk_4373e8ab-22fb-457b-a3ce-2c27e33a8aa9",
  });

  document.querySelector('#mtmenquiry').addEventListener("submit", function (event) {
    event.preventDefault();

    document.querySelector('#mtmenquiry').classList.toggle('hidden');
    document.querySelector('#mtmsubmit').classList.toggle('hidden');

    var thename = document.querySelector('#mtmenquiry input[name="contact[name]"]').value;
    var theemail = document.querySelector('#mtmenquiry input[name="contact[email]"]').value;
    var thephone = document.querySelector('#mtmenquiry input[name="contact[phone]"]').value;
    var thestore = document.querySelector('#mtmenquiry select[name="contact[store]"]').value;
    var theassociate = document.querySelector('#mtmenquiry select[name="contact[associate]"]').value
    var themessage = document.querySelector('#mtmenquiry textarea[name="contact[body]"]').value;
    botpoison.challenge().then(({
      solution
    }) => {
      fetch("https://submit-form.com/fY8fKHAj", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            name: thename,
            email: theemail,
            phone: thephone,
            store: thestore,
            associate: theassociate,
            message: themessage,
            _botpoison: solution,
          }),
        })
        .then(function (response) {
          document.querySelector("#mtmenquiry").reset();
          document.querySelector('#mtmsubmit').classList.toggle('hidden');
          document.querySelector('#mtmsuccess').classList.toggle('hidden');
        })
        .catch(function (error) {
          console.error(error);
          alert('There was an error.');
        });
    });
  })
}


// formspark consultation
var contactForm = document.querySelector('#consultationenquiry');
if (contactForm != null) {
  const botpoison = new Botpoison({
    publicKey: "pk_256e6709-e3d0-4d63-a97a-e1d5a2f60f2a",
  });

  document.querySelector('#consultationenquiry').addEventListener("submit", function (event) {
    event.preventDefault();

    document.querySelector('#consultationenquiry').classList.toggle('hidden');
    document.querySelector('#consultationsubmit').classList.toggle('hidden');

    var thename = document.querySelector('#consultationenquiry input[name="contact[name]"]').value;
    var theemail = document.querySelector('#consultationenquiry input[name="contact[email]"]').value;
    var theurl = document.querySelector('#consultationenquiry input[name="contact[url]"]').value;
    var thephone = document.querySelector('#consultationenquiry input[name="contact[phone]"]').value;
    var thestore = document.querySelector('#consultationenquiry select[name="contact[store]"]').value;
    var themessage = document.querySelector('#consultationenquiry textarea[name="contact[body]"]').value;
    botpoison.challenge().then(({
      solution
    }) => {
      fetch("https://submit-form.com/yzvdyf9y", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            name: thename,
            email: theemail,
            url: theurl,
            phone: thephone,
            store: thestore,
            message: themessage,
            _botpoison: solution,
          }),
        })
        .then(function (response) {
          document.querySelector("#consultationenquiry").reset();
          document.querySelector('#consultationsubmit').classList.toggle('hidden');
          document.querySelector('#consultationsuccess').classList.toggle('hidden');
        })
        .catch(function (error) {
          console.error(error);
          alert('There was an error.');
        });
    });
  })
}

// formspark product enquiry
var productForm = document.querySelector('#customenquiry');
if (productForm != null) {
  const botpoisonEnquiry = new Botpoison({
    publicKey: "pk_07fb4331-2859-40f8-aba0-e12edc46521e",
  });

  const enquiryForms = Array.from(document.querySelectorAll('#customenquiry'));

  enquiryForms.forEach(theForm => {
    theForm.addEventListener("submit", function (event) {
      event.preventDefault();
      let theForm = this;
      let targetForm = this.getAttribute('data-form');
      theForm.querySelector('.frm-field_submit').style.pointerEvents = "none";

      theForm.classList.toggle('hidden');
      theForm.parentNode.querySelector('.frm-field_submit_loading').classList.toggle('hidden');

      var nameData = document.querySelector(`form.${targetForm} input[name="contact[name]"]`).value;
      var emailData = document.querySelector(`form.${targetForm} input[name="contact[email]"]`).value;
      var subjectData = document.querySelector(`form.${targetForm} input[name="contact[Custom Enquiry Subject]"]`).value;
      var urlData = document.querySelector(`form.${targetForm} input.the-url`).value;
      var phoneData = document.querySelector(`form.${targetForm} input[name="contact[phone]"]`).value;
      var sizeData = document.querySelector(`form.${targetForm} input[name="contact[size]"]`).value;
      var messageData = document.querySelector(`form.${targetForm} textarea[name="contact[body]"]`).value;

      botpoisonEnquiry.challenge().then(({
        solution
      }) => {
        fetch("https://submit-form.com/x9mtrX11", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              subject: subjectData,
              url: urlData,
              name: nameData,
              email: emailData,
              phone: phoneData,
              size: sizeData,
              message: messageData,
              _botpoison: solution,
            }),
          })
          .then(function (response) {
            theForm.reset();
            theForm.parentNode.querySelector('.frm-field_submit_loading').classList.toggle('hidden');
            theForm.parentNode.querySelector('.frm-field_submit_success').classList.toggle('hidden');
          })
          .catch(function (error) {
            console.error(error);
            alert('There was an error.');
          });
      });
    })
  });

}


// Cookies

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

function getCookie(cname) {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': `application/${type}`
    }
  };
};


/* Toggle Class Generic */
function toggleClass(e) {
  var modal = document.querySelector(e);
  modal.classList.toggle("active");
}


/* Toggle Active Group */
function toggleActiveGroup(e, p, s, c) {
  var sibs = p.querySelectorAll(s);

  if (e.classList.contains("active")) {
    e.classList.remove("active");
    p.classList.remove("active");
    window.setTimeout(function () {
      e.parentNode.classList.remove("active");
    }, 610);
  } else {
    e.parentNode.classList.remove("active");
    for (i = 0; i < sibs.length; i++) {
      sibs[i].classList.remove("active");
    }

    if (c) {
      if (p.classList.contains("active")) {
        e.parentNode.classList.add("active");
        e.classList.add("active");
      } else {
        e.parentNode.classList.add("active");
        e.classList.add("active");
      }
    } else {
      e.classList.add("active");
      p.classList.add("active");
    }
  }
}
if (window.screen.width > 1023) {
  function hoverClick(e) {
    if (!e.parentNode.classList.contains('active')) {
      timer = window.setTimeout(function () {
        e.querySelector('.weddings__grid-button').click()
      }, 610);
    }
  }
}

/* Shrink Work Card */
const workCard = document.querySelectorAll(".shrink");

if (workCard) {
  workCard.forEach((targetDetail) => {
    targetDetail.addEventListener("mouseleave", function () {
      if (targetDetail.classList.contains("active")) {
        targetDetail.classList.remove("active");
      }
    });
  });
}


/* Hover List Hovers */
var hoverBlocks = document.querySelectorAll(".hover-list__list-items");

if (hoverBlocks) {
  hoverBlocks.forEach((targetDetail) => {
    var hoverItems = targetDetail.querySelectorAll("li");
    var itemListFirst = targetDetail.querySelectorAll("li");
    var itemPairFirst = targetDetail.parentNode.querySelectorAll(".hover-list__list-content li")

    if (hoverItems) {
      hoverItems.forEach((targetItem) => {
        var itemIndex = targetItem.getAttribute("data-index");
        var itemPair = targetItem.parentNode.parentNode.querySelector(".hover-list__list-content [data-index='" + itemIndex + "']")

        targetItem.addEventListener("click", function () {

          for (let i = 0; i < itemListFirst.length; i++) {
            itemListFirst[i].classList.remove("active");
            itemPairFirst[i].classList.remove("active");
          }
          targetItem.classList.add("active");
          itemPair.classList.add("active");
        });

      });
    }
  });
}


/*

  Init lazyload

*/
var lazyLoadInstance = new LazyLoad({
  elements_selector: ".lazy"
});

//------
// FROM samantha.js START
//------

//Slider
$('.responsive').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  arrows: true,
  dots: false,
  prevArrow: '<span class="slick-left">&#60;</span>',
  nextArrow: '<span class="slick-right">&#62;</span>',
  responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


//Header Nav Mobile
// const burger_menu = document.getElementById("burger_menu_icon");
const top_nav_list = document.getElementById("sh-nav-con");

// burger_menu.addEventListener("click", function() {
//   this.classList.toggle("opened");
//   top_nav_list.classList.toggle("show");
//   lockScroll();
// });

function lockScroll() {
  if ($('body').hasClass('lock-scroll')) {
    $('body').removeClass('lock-scroll');
  } else {
    $('body').addClass('lock-scroll');
  }
}

//Header Nav create a new account
$("#signin-button").on('click', function () {
  $("#login").addClass('show');
});
$("#search-button").on('click', function () {
  $("#search").addClass('show');
});

$("#close_login_icon").click(function () {
  $("#login").removeClass('show');
});
$("#close_search_icon").click(function () {
  $("#search").removeClass('show');
});

// FAQs Toggle

$(document).on('click', '.question-blocks', function (event) {

  if ($(this).data('question') == 0) {
    $(this).addClass('toggle-open');
    $('.togg-text', this).slideDown();
    $(this).data('question', 1);
    $('.togg-question', this).addClass('togg-icon');
    return;
  }

  if ($(this).data('question') == 1) {
    $(this).removeClass('toggle-open');
    $('.togg-text', this).slideUp();
    $(this).data('question', 0);
    $('.togg-question', this).addClass('togg-icon');
  }

});

var acc = document.getElementsByClassName("question-blocks");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var togg = this.nextElementSibling;
    if (togg.style.display === "block") {
      togg.style.display = "none";
    } else {
      togg.style.display = "block";
    }
  });
}

let add_btn = document.getElementById('sa_new_address');
let new_form = document.getElementById('sa_new_form');
let cancel_btn = document.getElementById('sa_new_cancel');

$(document).on('click', '#sa_new_address', function () {

  if ($(this).data('on') == 0) {
    open_new_address($(this));
    return;
  }

  if ($(this).data('on') == 1) {
    close_new_address($(this));
    return;
  }

});

$(document).on('click', '#sa_new_cancel', function () {

  close_new_address($('#sa_new_address'));
  return;

});

function open_new_address(ele) {
  $('#sa_new_form').slideDown();
  ele.data('on', 1);
  ele.text('Cancel');
  return;
}

function close_new_address(ele) {
  $('#sa_new_form').slideUp();
  ele.data('on', 0);
  ele.text(ele.data('title'));
  return;
}

$(document).on('click', '.edit-address-btn', function () {

  let ele = $(this).parent().find('.edit-address')
  ele.show();


  $([document.documentElement, document.body]).animate({
    scrollTop: ele.offset().top
  }, 500);

});

$(document).on('click', '.edit-address-cancel', function (e) {
  e.preventDefault();
  $('.edit-address').hide();

});

//size-popup
$("#size-list").click(function () {
  $("#size-popup").addClass('show');
  $('body').addClass('stop-scroll');
});
$("#close_pop_icon").click(function () {
  $("#size-popup").removeClass('show');
  $('body').removeClass('stop-scroll');
});


//------
// FROM samantha.js END
//------



/*

  snippet/video.liquid

*/
$(document).on('click', '.ki-play', function () {

  let the_frame = $('.ki-the-frame');
  the_frame.attr("src", the_frame.data("autoplay-src"));


  $('.ki-play').fadeOut();
  $('.ki-image-overlay').fadeOut();

  setTimeout(function () {
    $('.ki-overlay-load').css('opacity', 0.9);
  }, 500);

  setTimeout(function () {
    $('.ki-overlay-load').css('opacity', 0);
  }, 1000);

  setTimeout(function () {
    $('.ki-overlay-load').hide();
  }, 2500);



});

/*

  Gallery

*/
$('.pst-gi').lightGallery({
  selector: '.image-con'
});

// Gallery NT
$('.section-gridded-content').lightGallery({
  selector: '.img'
});

/*

  Single product image slider

*/
document.addEventListener('DOMContentLoaded', (event) => {

  var weddingsCarousels = $(".weddings__grid-carousel");
  weddingsCarousels.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    console.log("hello");
    var i = (currentSlide ? currentSlide : 0) + 1;
    $(this).parent().children(".weddings__grid-counter").html('<span class="font_b current_slide">' + i + '</span> / <span class="font_b total_slides"> ' + slick.slideCount + '</span>');
  });

  weddingsCarousels.each(function () {
    $(this).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      arrows: true,
      adaptiveHeight: false,
      prevArrow: '<div class="slick-left"><span><svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none"><path d="M5.5 1L1 5.5M1 5.5L5.5 10M1 5.5L11 5.5" stroke="white" stroke-width="1.2"/></svg></span></div>',
      nextArrow: '<div class="slick-right"><span><svg xmlns="http://www.w3.org/2000/svg" width="14" height="19" viewBox="0 0 14 19" fill="none"><path d="M7.5 5L12 9.5M12 9.5L7.5 14M12 9.5H2" stroke="white" stroke-width="1.2"/></svg></span></div>'
    });
  });


  // Product Details Slider
  $('#slider-details').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    // arrows: true,
    fade: true,
    adaptiveHeight: true,
    // prevArrow: '<div class="slick-left"><span>&#60;</span></div>',
    // nextArrow: '<div class="slick-right"><span>&#62;</span></div>'
  });

  $('#slider-details .pdp-details-nav__prev').click(function () {
    $("#slider-details").slick('slickPrev');
  });

  $('#slider-details .pdp-details-nav__next').click(function () {
    $("#slider-details").slick('slickNext');
  });

  $('.product-display .slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    adaptiveHeight: true,
    dots: true,
    prevArrow: '<div class="slick-left"><span>&#60;</span></div>',
    nextArrow: '<div class="slick-right"><span>&#62;</span></div>'
  });

  $('.product-display .slider-for').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    $(`.pdp .gallery-thumbs li button:not([data-index="${nextSlide}"])`).removeClass('active');
    $(`.pdp .gallery-thumbs li button[data-index="${nextSlide}"]`).addClass('active');
  });


});

function handleSliderNav(index) {
  $(".product-display .slider-for").slick('slickGoTo', index);
  $(`.pdp .gallery-thumbs li button:not([data-index="${index}"])`).removeClass('active');
  $(`.pdp .gallery-thumbs li button[data-index="${index}"]`).addClass('active');
}





/*
  cart quantity update
  For each cart body apply - / + events
*/

document.querySelectorAll('.cart-body').forEach(item => {

  let c = item.dataset.cart;
  let e_add = item.querySelector('.add-' + c);
  let e_sub = item.querySelector('.sub-' + c);
  let q_err = item.querySelector('.qty-error-' + c);



  // Add
  e_add.addEventListener('click', function (e) {
    q_err.innerHTML = ''; // reset err
    let max_qty = parseInt(e.target.dataset.maxqty);
    let e_input = item.querySelector('.cart-qty-input-' + c);
    let current_qty = parseInt(e_input.value);
    let new_qty = current_qty + 1;

    if (current_qty < max_qty) {
      e_input.value = new_qty;
    }

    if (current_qty == max_qty) {
      q_err.innerHTML = 'You have reached the maximum available stock';
    }
  });

  // Subtract
  e_sub.addEventListener('click', function (e) {
    q_err.innerHTML = ''; // reset err
    let e_input = item.querySelector('.cart-qty-input-' + c);
    let current_qty = parseInt(e_input.value);
    let new_qty = current_qty - 1;

    if (current_qty > 1) {
      e_input.value = new_qty;
    }

  });

});


/*

  Custom enquiry pop up

*/

//open
$(document).on('click', '.ce-open', function (e) {
  e.preventDefault();
  let data_id = $(this).data('id');
  // $('#ce_'+data_id).fadeIn();
  document.querySelector(`#ce_${data_id}`).classList.add('active');

});
// close
$(document).on('click', '.ce-close', function () {
  var target = this.getAttribute('data-target');
  document.querySelector(`#${target}`).classList.remove('active');

});
$(document).on('click', '.enquiry-close', function () {
  document.querySelector(`.snippet-custom-enquiry`).classList.remove('active');

});

// add current url to hidden field
$('.the-url').val(window.location.href);

// toast: vars
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

// toast: if ?contact_posted=true then do_toast
if (urlParams.has('contact_posted')) {

  const contact_outcome = urlParams.get('contact_posted');

  if (contact_outcome == 'true') {
    do_toast(true, 'Submission successful');
  }
  if (contact_outcome == 'false') {
    do_toast(false, 'Submission failed, please try again later');
  }

};

// toast: do toast function
function do_toast(bool = true, message, display_time = 5000) {

  let toast_html = html_toast(bool, message);

  $('body').prepend(toast_html);

  setTimeout(function () {
    $('.js-toast').css('top', 0);
  }, 200);

  setTimeout(function () {
    $('.js-toast').hide();
  }, display_time);

}

// toast: html
function html_toast(bool = true, message) {

  var toast_classname = (bool == true) ? "toast-success" : "toast-error";

  return `<div class="js-toast">
 <div class="kontainer">
   <div class="this-box">
     <p class="${toast_classname}">${message}</p>
   </div>
 </div>
</div>`;

}

// toast: if clicked hide it.
$(document).on('click', '.js-toast', function () {
  $(this).hide();
})

// toast: when reset pwd submission is success
if ($('#recover-success-submission').length) {
  let message = $('#recover-success-submission').text();
  do_toast(true, message, 8000);
}

// Wishlist: overwrite empty list
function empty_wishlist() {
  setTimeout(function () {

    let ele_emptylist = $('.swym-empty-wishlist-container');


    ele_emptylist.html('<p style="font-size:1.75em">Your wishlist is empty!</p>')
    ele_emptylist.css('visibility', 'visible');

  }, 2000);
}

empty_wishlist();

/*

  JS redirects

*/

function redirects() {

  let url_path = window.location.pathname;
  let url_segments = url_path.split('/');

  // Redirects /blogs/what-we-do/ > /pages/what-we-do
  if (url_segments[1] == 'blogs' && url_segments[2] == 'what-we-do' && url_segments[3] == undefined) {
    window.location = '/pages/what-we-do';
  }

}
redirects();

function is_in_array(value, array) {
  return array.indexOf(value) > -1;
}

/*

  localstate organiser for product filter.
  created here instead of product-filter.js as it was required globally.
  Purpose:
    To reset the product filter if navigating away.

*/
var el_collection_handle = document.getElementById('the_products');
var collection_handle = (el_collection_handle != null ? el_collection_handle.dataset.collection : false)
var io_constructor = localStorage.getItem('io_constructor');

/*
  Creates constructor localstorage and organise the io_localstate_$ data.
*/
function localstate_constructor() {

  if (io_constructor != null) {

    let io_cons_data = JSON.parse(io_constructor);

    // Add current collection handle to io_cons_data.used if it isn't in there already
    if (!is_in_array(collection_handle, io_cons_data.used)) {
      io_cons_data.used.push(collection_handle);
    }

    io_cons_data.allowed = collection_handle;

    // Create the io_constructor
    localStorage.setItem('io_constructor', JSON.stringify(io_cons_data));

  } else {

    localstate_reset();

  }

}

/*
  Remove all io_localstate_$ unless the page is itself then don' remove it.
*/
function localstate_remove() {

  if (io_constructor != null) {

    let io_cons_data = JSON.parse(io_constructor);

    io_cons_data.used.forEach((collectionHandle) => {

      if (collection_handle != io_cons_data.allowed) {

        localStorage.removeItem('io_localstate_' + collectionHandle);

      }

    });

    localstate_reset();

  }

}

/*
  Reset the io_constructor value to
  the current collection handle
*/
function localstate_reset() {

  let io_cons_data_new = {
    used: [collection_handle],
    allowed: collection_handle
  }

  localStorage.setItem('io_constructor', JSON.stringify(io_cons_data_new));

}

/*
  Remove all io_localstate_$ first then remove io_constructor
*/
function localstate_remove_permenantely() {

  if (io_constructor != null) {

    let io_cons_data = JSON.parse(io_constructor);

    // {used: [...]}
    io_cons_data.used.forEach((collectionHandle) => {

      if (collection_handle != io_cons_data.allowed) {

        localStorage.removeItem('io_localstate_' + collectionHandle);

      }

    });

    localStorage.removeItem('io_constructor');

  }

}

/*
  Initialise the localstate organiser
*/
function localstate_init() {

  localstate_constructor();
  localstate_remove();

  let el_pageTemplate = document.getElementById('PageTemplate');

  // If not a collection page remove all io_$
  if (el_pageTemplate != null) {
    if (el_pageTemplate.dataset.templatename != 'collection') {
      localstate_remove_permenantely();
    }
  }

}
localstate_init();


/*============================================================================
Utility: Local Storage Expiry Time
==============================================================================*/
const util = {
  setWithExpiry: (key, value, ttl = 86400000) => {
    const now = new Date()
    // 24 hours in miliseconds is 86400000
    // `item` is an object which contains the original value
    // as well as the time when it's supposed to expire
    const item = {
      value: value,
      expiry: now.getTime() + ttl,
    }
    localStorage.setItem(key, JSON.stringify(item))
  },
  getWithExpiry: (key) => {
    const itemStr = localStorage.getItem(key)
    // if the item doesn't exist, return null
    if (!itemStr) {
      return null
    }
    const item = JSON.parse(itemStr)
    const now = new Date()
    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
      // If the item is expired, delete the item from storage
      // and return null
      localStorage.removeItem(key)
      return null
    }
    return item.value
  }
};

/*
  Currency dropdown - Show/Hide dropdown
*/
const el_cdlCurrent = document.getElementById('CdlCurrent');
const el_cdlCurrentName = el_cdlCurrent.querySelector('.this-name');
const el_cdlItems = document.getElementById('CdlItems');
const el_icon = document.querySelector('.currency-dropdown-list .this-icon');
const currencyForm = document.getElementById('currency_form');

el_cdlCurrent.addEventListener('click', function () {
  if (parseInt(this.dataset.show) == 0) {
    currencyListShow();
    return;
  }
  if (parseInt(this.dataset.show) == 1) {
    currencyListHide();
    return;
  }
});

function currencyListShow() {
  el_cdlItems.style.display = 'block';
  el_cdlCurrent.dataset.show = 1;
  el_icon.classList.add('rotate-180');
}

function currencyListHide() {
  el_cdlItems.style.display = 'none';
  el_cdlCurrent.dataset.show = 0;
  el_icon.classList.remove('rotate-180');
}

/*
  Currency dropdown - Submit hidden form on selection of the currency dropdown
*/

const els_currencyList = document.querySelectorAll('.cdl-items li');

els_currencyList.forEach(function (item) {

  const countryLi = item.dataset.country;
  item.addEventListener('click', function () {

    const el_countryOption = document.getElementById("countryCode" + countryLi);

    if (el_countryOption) {
      el_countryOption.selected = true;
      currencyForm.submit();
    }
  });

});

// Currency Dropdown Mobile
// const el_cdlCurrentMob     = document.getElementById('CdlCurrentMob');
// const el_cdlCurrentNameMob = el_cdlCurrent.querySelector('.this-name-mob');
// const el_cdlItemsMob       = document.getElementById('CdlItemsMob');
// const el_iconMob           = document.querySelector('.currency-dropdown-list-mob .this-icon');
// const currencyFormMob      = document.getElementById('currency_form_mob');

// el_cdlCurrentMob.addEventListener('click', function(){
//   if(parseInt(this.dataset.show) == 0){
//     currencyListShow();
//     return;
//   }
//   if(parseInt(this.dataset.show) == 1){
//     currencyListHide();
//     return;
//   }
// });

// function currencyListShow(){
//   el_cdlItemsMob.style.display = 'block';
//   el_cdlCurrentMob.dataset.show = 1;
//   el_iconMob.classList.add('rotate-180');
// }

// function currencyListHide(){
//   el_cdlItemsMob.style.display = 'none';
//   el_cdlCurrentMob.dataset.show = 0;
//   el_icon.classListMob.remove('rotate-180');
// }

// /*
//   Currency dropdown - Submit hidden form on selection of the currency dropdown
// */

// const els_currencyListMob = document.querySelectorAll('#CdlItemsMob li');

// els_currencyList.forEach(function(item){

//   const countryLi = item.dataset.country;
//   item.addEventListener('click', function(){

//     const el_countryOption = document.getElementById("countryCode"+countryLi);

//     if(el_countryOption){
//       el_countryOption.selected = true;
//       currencyForm.submit();
//     }
//   });

// });

/*

  > Fetches visitors county from geojs.io
  > Matches the visitors country to a option in the currency dropdown
  > Sets a localstorage to avoid loop
  > Then submits the form.

  Note: data-country="$", is actually the iso currency code with the last character removed.

*/
function autoLoadCurrency() {

  $.ajax({
    url: "https://get.geojs.io/v1/ip/country.json",
  }).done(function (response) {
    const {
      country
    } = response;
    const geoSet = localStorage.getItem('geoSet');
    if (!geoSet) {

      localStorage.setItem('geoSet', country); // set, to avoid loop
      const el_countryOption = document.getElementById("countryCode" + country);

      // popup only shows if the users country is available in the shops currency list which is define by shop staff.
      if (el_countryOption) {
        el_countryOption.selected = true;
        currencyForm.submit();



        /*
        1. show popup

        2. user feedback: 
        We've detected you are visiting from $CountryName.
        Would you like to change the currency to $CurrencyCode?

        if cancel close popup // mark cookie
        if yes do submission // mark cookie
        

        3. 
        */
      }

    }

  });

}

const UsersCountry = {
  $body: document.body,
  noScrollClass: 'noScroll',
  el_popup: document.getElementById("JsPopupCountryDetect"),
  popupCloseId: "currency-popup-close",
  popupAcceptId: "currency-popup-accept",
  $popupAcceptId: document.getElementById(this.popupAcceptId),
  localHidePopupId: 'hideAutoCurrency',
  $currencyForm: document.getElementById('currency_form'),
  popupHTML: function (content) {

    const countryName = () => {
      if (content.countryCode === 'US') {
        return `the US`;
      } else if (content.countryCode === 'GB') {
        return `the UK`;
      } else {
        return content.countryCode;
      };
    }
    return `
    <div class="kontainer">

      <div class="jpcd-box">
        <div class="this-content">
          <p>We've detected you are browsing from ${countryName()}</p>
        </div>

        <div class="this-buttons">
          <ul>
            <li><span id="${this.popupCloseId}" class="btn-box">Cancel</span></li>
            <li><span id="${this.popupAcceptId}" class="btn-box">Change Currency to ${content.currencyVal}</span></li>
          </ul>
        </div>
      </div>
    
    </div>
    `;
  },
  popupShow: function (content) {
    this.$body.classList.add(this.noScrollClass);
    this.el_popup.innerHTML = this.popupHTML(content);
    this.el_popup.classList.add("js-popup-country-detect");

    this.el_popup.style.display = "initial";
    this.el_popup.style.opacity = 1;
  },
  popupClose: function () {
    const $popupCloseId = document.getElementById(this.popupCloseId);

    $popupCloseId.addEventListener("click", () => {
      this.el_popup.remove();
      this.$body.classList.remove(this.noScrollClass);
      util.setWithExpiry(this.localHidePopupId, true);
    });
  },
  changeCurrency: function ({
    currencyVal
  }) {
    const $popupAcceptId = document.getElementById(this.popupAcceptId);

    $popupAcceptId.addEventListener("click", () => {
      const $select = this.$currencyForm.querySelector('select');

      $select.value = currencyVal;
      this.$currencyForm.submit();
    });
  },
  init: function () {
    $.ajax({
      url: "https://get.geojs.io/v1/ip/country.json",
    }).done(
      function (response) {
        const {
          country
        } = response;
        const geoSet = localStorage.getItem("geoSet");

        if (!geoSet) {
          //localStorage.setItem('geoSet',country); // set, to avoid loop
          const el_countryOption = document.getElementById(
            "countryCode" + country
          );

          // popup does no show if user's country already selected
          const $select = this.$currencyForm.querySelector('select');
          const currentCountry = $select.options[$select.selectedIndex].getAttribute('data-country');
          if (currentCountry === country) return;

          // if user closed the popup before, do not show popup
          if (util.getWithExpiry(this.localHidePopupId) === true) return;

          // popup only shows if the user's country is available in the shops currency list which is define by shop staff.
          if (el_countryOption) {
            //Get currency code
            const currencyVal = $select.querySelector(`option[data-country=${country}]`).value;
            this.popupShow({
              countryCode: country,
              currencyVal: currencyVal
            });

            //On click button, close
            this.popupClose();

            //On click button, change currency
            this.changeCurrency({
              currencyVal: currencyVal
            });
          }
        }
      }.bind(this)
    );
  },
};

UsersCountry.init();

// autoLoadCurrency();

/*

  Header work.
  Pushes body content down by the height of the header.
  Nav row top/bot padding is decreased on scroll.
  
*/
const Header = {
  el_shopifyHeader: document.getElementById('shopify-section-header'),
  el_sectionHeader: document.getElementById('section-header'),
  el_main: document.getElementById('theMain'),
  el_topBanner: document.querySelector('.snippet-top-banner-notification'),
  pushBodyContentDown: function () {
    //   const headerHeight = this.el_shopifyHeader.offsetHeight;
    //   this.el_main.style.paddingTop = headerHeight+'px';

  },
  minimiseHeaderPadding: function () {
    const h = this.el_sectionHeader;
    $(document).scroll(function () {
      const currentPosition = $(document).scrollTop();
      if (currentPosition >= 300) {
        h.classList.add('section-header-scrolled')
      }
      if (currentPosition < 300) {
        h.classList.remove('section-header-scrolled')
      }
    });

  },
  init: function () {

    if (this.el_shopifyHeader != null && this.el_sectionHeader != null) {
      this.pushBodyContentDown();
    }

    if (this.el_topBanner != null) {
      this.minimiseHeaderPadding();
    }

  }
}

Header.init();


/*============================================================================
Size Guide
==============================================================================*/
const sizeGuide = () => {
  if (document.querySelector('.size-content')) {
    $('#size-list-col').removeClass('hide');
  }
};

sizeGuide();

/*============================================================================
HEADER
==============================================================================*/

// Announcemet Bar
let annBar = document.querySelector('#announcement-bar');
let videoObserver = new IntersectionObserver((entries, videoObserver) => {
  entries.forEach(entry => {
    if (entry.intersectionRatio != 1) {
      document.querySelector('body').classList.remove('announcement-visible');
    } else {
      document.querySelector('body').classList.add('announcement-visible');
    }
  });
}, {
  threshold: 1
});

if (annBar) {
  videoObserver.observe(annBar);
}

var shopHeader = document.querySelector('#header');
var headerDropdown = document.querySelector('#header .dropdown');
var headerBurger = document.querySelector('#header .burger');

headerBurger.addEventListener("click", (event) => {
  document.querySelector('#menuMobile').classList.toggle('active');
  document.querySelector('#header').classList.toggle('active');
});

const submenuTriggers = Array.from(document.querySelectorAll('#headerDropdown a[data-submenu]'));
const submenus = Array.from(document.querySelectorAll('#headerDropdown .submenu'));

document.querySelector('#shopTrigger span').addEventListener("mouseenter", (event) => {
  showHeaderDropdown();
});

document.querySelector('#header .h-secondary').addEventListener("mouseenter", (event) => {
  showHeaderDropdown();
});

document.querySelector('#headerMask').addEventListener("mouseover", (event) => {
  hideSubmenus();
  document.querySelector('#header').classList.remove('active');
  document.querySelector('#headerMask').classList.remove('active');
  // lockScroll();
});

function showHeaderDropdown() {
  document.querySelector('#header').classList.add('active');
  document.querySelector('#headerMask').classList.add('active');
  // lockScroll();
}

function hideSubmenus() {
  submenus.forEach(submenu => {
    submenu.classList.remove('active');
  });
}

submenuTriggers.forEach(trigger => {
  trigger.addEventListener("mouseenter", (event) => {
    var targetMenu = trigger.getAttribute('data-submenu');
    hideSubmenus();
    document.querySelector(`#headerDropdown .submenu[data-id="${targetMenu}"]`).classList.add('active');
  });
});

// Mobile Menu
var mobileShop = document.querySelector('#menuMobile .mob-shop');
mobileShop.addEventListener("click", (event) => {
  document.querySelector('#menuMobile .p2').classList.add('active');
});

var mobileShopBack = document.querySelector('#menuMobile .mob-shop-back');
mobileShopBack.addEventListener("click", (event) => {
  document.querySelector('#menuMobile .p2').classList.remove('active');
});

const mobSubmenuTriggers = Array.from(document.querySelectorAll('#menuMobile .parent[data-mobsubmenu]'));
const mobSubmenus = Array.from(document.querySelectorAll('#menuMobile .mob-submenu'));

function hideMobsubmenus() {
  mobSubmenus.forEach(submenu => {
    submenu.classList.remove('active');
  });
}

mobSubmenuTriggers.forEach(trigger => {
  trigger.addEventListener("click", (event) => {
    event.preventDefault();
    var targetMenu = trigger.getAttribute('data-mobsubmenu');
    hideMobsubmenus();
    document.querySelector(`#menuMobile .mob-submenu[data-id="${targetMenu}"]`).classList.add('active');
  });
});

const mobSubmenuClose = Array.from(document.querySelectorAll('#menuMobile .mob-submenu-back'));
mobSubmenuClose.forEach(trigger => {
  trigger.addEventListener("click", (event) => {
    hideMobsubmenus();
  });
});

// SEARCH
var searchClose = document.querySelector('#searchModal .close');
var searchModal = document.querySelector('#searchModal');
var searchToggles = Array.from(document.querySelectorAll('.searchToggle'));

function openSearch() {
  searchModal.classList.add('active');
  shopHeader.classList.remove('active');
  document.querySelector('#menuMobile').classList.remove('active');
  setTimeout(() => {
    document.querySelector("#searchModal input[type='search'").focus();
  }, 300)
}

function closeSearch() {
  searchModal.classList.remove('active');
}

searchClose.addEventListener("click", (event) => {
  shopHeader.classList.remove('active');
  closeSearch();
});

searchToggles.forEach(toggle => {
  toggle.addEventListener("click", (event) => {
    event.preventDefault();
    openSearch();
  });
});

// PDP Metafield Accordions
var pdpMetafieldAccordions = Array.from(document.querySelectorAll('.pdp .pdp-metafield .toggle'));

function toggleMetafieldAccordion(toggle) {
  toggle.closest('.pdp-metafield').classList.toggle('active');
}

pdpMetafieldAccordions.forEach(toggle => {
  toggle.addEventListener("click", (event) => {
    toggleMetafieldAccordion(toggle);
  });
});


/* Quick Cart */
var body = document.querySelector("body");

function cartOpen() {
  body.classList.add("js-my-cart-open");
}


/* Screen Height */
var headerInner = document.querySelector("#header .inner");
var bar = document.querySelector("#shopify-section-announcement-bar");

function setScreenHeight() {
  document.documentElement.style.setProperty('--Hc', headerInner.clientHeight + bar.clientHeight + "px");
}

setScreenHeight();

window.addEventListener("resize", setScreenHeight);